var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "gift-bear.7bfdf3dd.png","uri@2x": __webpack_public_path__ + "gift-bear.fdefd736.png","uri@3x": __webpack_public_path__ + "gift-bear.b76f9cf5.png",
    width: 87,
    height: 91
});